var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "90px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          stripe: false,
          selection: _vm.selection,
          height: _vm.height - 48,
          "reset-btn-hide": "",
          "right-toolbar-hide": "",
          "tag-name": "skuCode",
          "show-tags": "",
          "tag-x": "",
          disabled: _vm.disabledNotSelected,
          "row-key": "id",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.spuCode"),
                          prop: "spuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: "商品编码",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.spuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "spuCode", $$v)
                            },
                            expression: "queryParams.spuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.skuCode"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: "SKU编码",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    prop: "spuCode",
                    label: "商品编码",
                    width: "150",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "skuCode",
                    label: "SKU编码",
                    width: "150",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "num",
                    label: "数量",
                    width: "50",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "spuName",
                    label: "商品名称",
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "paginationBottom",
            fn: function () {
              return [
                _c(
                  "BjDivider",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "right",
                        fn: function () {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.onSearch },
                              },
                              [_vm._v("查询可发货逻辑仓")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [_vm._v(" 包裹商品 ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }